<template>
  <transition name="dark-message-fade" @after-leave="handleAfterLeave">
    <div
      v-show="visible"
      :class="['dark-message', type]"
      @mouseenter="clearTimer"
      @mouseleave="startTimer"
    >
      <img :src="iconSrc" class="dark-message__icon" />
      <span class="dark-message__text">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: "DarkMessage",
  props: {
    message: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "info", // success, warning, error, info
      validator: (value) =>
        ["success", "warning", "error", "info"].includes(value),
    },
    duration: {
      type: Number,
      default: 3000,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      timer: null,
    };
  },
  computed: {
    iconSrc() {
      // 假设图片在 packages/components/dark-message/assets/images/
      switch (this.type) {
        case "success":
          return require("../../../assets/images/icon/success-icon.png");
        case "warning":
          return require("../../../assets/images/icon/warn-icon.png");
        case "error":
          return require("../../../assets/images/icon/error-icon.png");
        default:
          return ""; // 或者一个默认的 info 图标
      }
    },
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (this.visible) {
            this.close();
          }
        }, this.duration);
      }
    },
    clearTimer() {
      clearTimeout(this.timer);
      this.timer = null;
    },
    close() {
      this.visible = false;
      if (typeof this.onClose === "function") {
        this.onClose();
      }
      // 动画结束后由handleAfterLeave销毁
    },
    handleAfterLeave() {
      this.$destroy();
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dark-message {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #27272a;
  border-radius: 8px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  position: fixed;
  left: 50%;
  top: 20px; // 初始位置
  transform: translateX(-50%);
  z-index: 20000; // 确保在其他内容之上
  min-width: 100px; // 最小宽度
  color: #ecedee; // 文字颜色
  font-size: 14px;
  line-height: 20px;
  box-sizing: border-box;
  opacity: 1;
  transition: opacity 0.3s, transform 0.3s, top 0.3s; // 添加动画效果

  &__icon {
    width: 24px; // 图标大小
    height: 24px;
    margin-right: 8px;
    flex-shrink: 0; // 防止图标缩小
  }

  &__text {
    flex-grow: 1;
  }

  // 不同类型消息的样式
  &.success {
    // 假设图标颜色和边框在图片中已经体现
  }
  &.warning {
    // 假设图标颜色和边框在图片中已经体现
  }
  &.error {
    // 假设图标颜色和边框在图片中已经体现
  }
}

// 过渡动画
.dark-message-fade-enter,
.dark-message-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px); // 向上滑出
}
.dark-message-fade-leave-active {
  position: absolute; // 确保离开时不会影响其他元素布局
}
</style>
